import React, { Fragment, Component } from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'
import { Overlay } from './ModalBase.styles'
import ModalWrapper from './ModalWrapper'

class ModalBase extends Component {
  static defaultProps = {
    show: false,
    canCloseByOverlay: true,
    canCloseByXBtn: true
  }

  handleClick = e => {
    this.props.onClose(e)
  }

  render() {
    const { show, children, fullScreen, canCloseByOverlay, ...rest } =
      this.props

    if (!show) return null

    const component = (
      <Fragment>
        <Overlay
          ref={ref => {
            this.overlay = ref
          }}
        />
        <ModalWrapper
          onClose={canCloseByOverlay ? this.handleClick : () => ({})}
          fullScreen={fullScreen}
          {...rest}
        >
          {children}
        </ModalWrapper>
      </Fragment>
    )

    if (process && process.env.NODE_ENV === 'test') {
      return component
    }

    return createPortal(component, document.getElementById('modal'))
  }
}

export const modalPropTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  canCloseByOverlay: PropTypes.bool,
  canCloseByXBtn: PropTypes.bool
}

ModalBase.propTypes = modalPropTypes

export default ModalBase
